import React, { useContext, useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Overlay from "../../../Overlay/index.jsx";
import Button from "../../../common/Button/index.jsx";
import {
  bankList,
  langComponent,
  PAGE_STATE,
} from "../../../../constants/index.jsx";
import useUsers from "../../../../hooks/useUsers.js";
import useBankAccount from "../../../../hooks/useBankAccount.js";
import { format } from "date-fns";
import AppContext from "../../../../AppContext.jsx";

import ComboBox from "../../../common/ComboBox/index.jsx";
import { Form, Formik } from "formik";
import TextBox from "../../../common/TextBox/index.jsx";
import TextArea from "../../../common/TextArea/index.jsx";
import { BankSvg } from "../../../../constants";

const prefix = "profile-edit-billing-account-modal";

const View = ({ editing: _editing, onClose, onSuccess }) => {
  const [editing, setEditing] = useState(_editing);
  const { getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.project);
  const [pageState, setPageState] = useState(
    editing ? PAGE_STATE.LOADING : PAGE_STATE.IDLE
  );
  const [savingState, setSavingState] = useState(PAGE_STATE.IDLE);

  const [initialValues, setInitialValues] = useState({
    brand: "",
    accountName: "",
    accountNo: "",
    desc: "",
    joined: "",
    active: "true",
    verified: false,
    activated: false,
  });
  const formikRef = useRef(null);
  const [bank, setBank] = useState(
    initialValues?.bank ? initialValues?.bank : ""
  );
  const {
    queryBankAccounts,
    getBankAccounts,
    patchBankAccounts,
    createBankAccounts,
  } = useBankAccount();

  const mappingBank = (bankKey, bankData) => {
    const { nice_name } = bankData;
    return {
      name: nice_name,
      value: bankKey,
      icon: BankSvg[bankKey],
    };
  };
  const _option = Object.entries(bankList.th).map(([bankKey, bankData]) =>
    mappingBank(bankKey, bankData)
  );

  useEffect(() => {
    if (!editing) return;
    fetchData();

    return () => {};
  }, []);

  const fetchData = async () => {
    const {
      recipientId,
      desc,
      taxId,
      verified,
      verifiedOn,
      activated,
      activatedOn,
      bank: { name, accountNo, brand },
      type,
      user,
      company,
      createdOn,
      active,
      deleted,
    } = await getBankAccounts(editing);

    const _joined = createdOn ? format(new Date(createdOn), "dd/MM/yyyy") : "-";

    setInitialValues({
      no: 1,
      desc,
      brand,
      accountName: name || "",
      accountNo: accountNo || "",
      joined: _joined,
      active: active,
      verified: verified,
      activated: activated,
    });

    setPageState(PAGE_STATE.IDLE);
  };

  const handleValidate = ({ bank, accountName, accountNo }) => {
    let errors = {};
    // if (!bank) errors.bank = "Required";
    if (!accountName) errors.accountName = "Required";
    if (!accountNo) errors.accountNo = "Required";
    return errors;
  };

  const handleSubmit = async (
    { brand, accountName, accountNo, desc },
    options
  ) => {
    setSavingState(PAGE_STATE.LOADING);

    // * Edit staff
    if (editing) {
      try {
        await patchStaff(editing, {
          desc,
          bank: {
            brand,
            name: accountName,
            accountNo: accountNo,
          },
        });

        setSavingState(PAGE_STATE.IDLE);
        onSuccess();
      } catch (error) {
        console.error(error.message);
        setSavingState(PAGE_STATE.ERROR);
      }
    }

    // * Create new bank account
    if (!editing) {
      try {
        const bankAccount = await createBankAccounts({
          desc,
          bank: {
            brand,
            name: accountName,
            accountNo: accountNo,
          },
        });

        setSavingState(PAGE_STATE.IDLE);
        onSuccess();
      } catch (error) {
        console.error(error.message);
        setSavingState(PAGE_STATE.ERROR);
      }
    }
  };

  if (pageState === PAGE_STATE.LOADING) {
    return <Overlay />;
  }

  return (
    <Overlay
      style={{
        alignItems: "flex-start",
      }}
      onClose={onClose}
      content={
        <div className={`${prefix}`}>
          <Formik
            initialValues={initialValues}
            innerRef={formikRef}
            validate={handleValidate}
            onSubmit={handleSubmit}
          >
            {({ isValid }) => {
              return (
                <Form autoComplete="off">
                  <h2 className={`${prefix}__header`}>
                    {editing ? "Edit Bank Account" : "Create Bank Account"}
                  </h2>
                  <div className={`${prefix}-info`}>
                    <TextBox label="Account Name" name="accountName" />
                    <TextBox
                      label="Account Number"
                      name="accountNo"
                      type="number"
                    />
                    <ComboBox
                      name="brand"
                      label={"Bank"}
                      defaultValue={initialValues.brand}
                      options={_option}
                      placeholder={Translation("Bank Name")}
                    />
                    <TextArea label="Description" name="desc" />
                  </div>
                  <div className={`${prefix}-footer`}>
                    {savingState === PAGE_STATE.LOADING && <>Saving...</>}
                    {savingState === PAGE_STATE.ERROR && <>Error saving</>}
                    {savingState === PAGE_STATE.IDLE && (
                      <Button
                        label={"Save"}
                        type="submit"
                        disabled={!isValid}
                      />
                    )}
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      }
    />
  );
};

View.propTypes = {
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  editing: PropTypes.string,
};

View.defaultProps = {
  onClose: () => {},
  onSuccess: () => {},
  editing: undefined,
};

export default View;
